import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/Layout.vue'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/Login.vue'),
    meta: {
      requiresAuth: false,
      showHeader: false,
      showSidebar: false,
      showFooter: false
    }
  },
  {
    path: '/',
    component: Layout, // 使用 Layout 作为父路由
    children: [
      {
        path: '', // 默认子路由
        component: () => import('@/views/Portal.vue'),
        meta: {
          requiresAuth: true,
          showHeader: true,
          showSidebar: true,
          showFooter: true
        },
        exact: true
      },
      {
        path: 'customer/new',
        component: () => import('@/views/NewCustomer.vue'),
        meta: {
          requiresAuth: true,
          showHeader: true,
          showSidebar: true,
          showFooter: true
        },
        exact: true
      },
      {
        path: 'address',
        component: () => import('@/views/Address.vue'),
        meta: {
          requiresAuth: true,
          showHeader: true,
          showSidebar: true,
          showFooter: true
        },
        exact: true
      },
      {
        path: 'vendor',
        component: () => import('@/views/Vendor.vue'),
        meta: {
          requiresAuth: true,
          showHeader: true,
          showSidebar: true,
          showFooter: true
        },
        exact: true
      }
      ,
      {
        path: 'settings',
        component: () => import('@/views/Settings.vue'),
        meta: {
          requiresAuth: true,
          showHeader: true,
          showSidebar: true,
          showFooter: true
        },
        exact: true
      }
    ]
  }
]

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (token) {
      next()
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

export default router
